import Spacer from "../../../../components/Spacer";
import React, { useEffect, useState } from "react";
import { IMG_URl } from "../../../../common/img_url";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../../components/header";
import { indexStore } from "../../../../store/indexStore";
import Visibility from "../../../../components/utils/Visibility";
import { useTranslation } from "react-i18next";
import OptionsProduct from "../../../../components/OptionsProduct/OptionsProduct";
import { Skeleton } from "../../../../components/ui/skeleton";
import {
  AddToCart,
  CalcQuantity,
} from "../../../../components/utils/CartFunctions";
import { Button } from "../../../../components/ui/button";
import IsNotActive from "../../../../components/IsNotActive/IsNotActive";
import ProductModel from "../../../../Models/PorductModel";
import NewProductScreen from "../../../../components/ProductScrens/NewProductScreen";
import OldProductScreen from "../../../../components/ProductScrens/OldProductScreen";
import { AddToRecentlyViewed } from "../../../../components/utils/RecentlyViewed";
function Product() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    name,
    description,
    product,
    fetchProductByAction,
    itemLoading,
    getStyle,
    style,
    restaurant,
    fetchBranchesAction,
  } = indexStore();
  const params = useParams();
  const paramsRequst = {
    domain: params.domain,
    branch_id: params.branch_id,
    menu_id: params.menu,
    product: params.product,
  };

  useEffect(() => {
    if (Object.keys(style).length === 0) {
      getStyle(paramsRequst);
    }
    fetchProductByAction({
      productId: paramsRequst.product,
      domain: params.domain,
    });
    if (Object.keys(restaurant).length === 0)
      fetchBranchesAction({ domain: params.domain });
  }, []);
  console.log(product, "product");

  useEffect(() => {
    if (Object.keys(product).length !== 0) {
      const menuId = params.menu !== undefined ? params.menu : "";
      AddToRecentlyViewed(
        { ...product, menu_id: menuId },
        Number(params.branch_id)
      );
    }
  }, [product]);
  const screen: number = 2;

  return (
    <IsNotActive>
      <div className="bg-background flex-grow">
        <title>{paramsRequst?.domain?.toUpperCase()}</title>
        <Visibility visible={screen == 1}>
          <OldProductScreen />
        </Visibility>
        <Visibility visible={screen == 2}>
          <NewProductScreen />
        </Visibility>
      </div>
    </IsNotActive>
  );
}

export default Product;
